import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useAuth, useProtectedContent } from "../../../context/AuthContext";
import callAPI from "../../../helpers/callAPI";
import serverColor from "../../../helpers/serverColor";
import Number from "../../../templates/Number/Number";
import { colors } from '../../../theme/variables';

{/* credits: "644239"
email_usage: "90154"
fingerprint_usage: "0"
ip_usage: "264510"
last_status_check_date: "2025-02-12T01:56:11.000Z"
mobile_sdk_usage: "0"
phone_usage: "1104"
success: true
total_credits: 1000007
total_usage: 355768
url_usage: "0" */}

const Summary = ({ dashboard }) => {
    const [init, setInit] = useState(true)

    const [data, setData] = useState()
    const [ipqsData, setIpqsData] = useState()
    const [sendgridData, setSendgridData] = useState()
    const [dataLoaded, setDataLoaded] = useState(false)

    const auth = useAuth()
    let ipqsUsageData = useProtectedContent(auth.permissions, 'ipqs_usage_check')
    let sendgridUsageData = useProtectedContent(auth.permissions, 'sendgrid_usage_data')
    const fetchData = async () => {
        setDataLoaded(false)
        let result = await callAPI(`mbStatus/monitoring/summary`, 'GET')

        if (result.success) {
            setData(result)
            setIpqsData(result.details.ipqsData)
            setSendgridData(result.details.sendgridUsage)
        }

        setDataLoaded(true)
    }

    useEffect(() => {
        if (init) {
            fetchData()
            setInit(false)
        }

        const interval = setInterval(() => {
            fetchData()
        }, 60000)
        return () => clearInterval(interval)
    }, [])

    const getStatus = (server) => {
        return data.details.applicationHealth.filter(item => item.name === server)[0].status
    }

    const getLastSuccessDate = (server) => {
        return data.details.applicationHealth.filter(item => item.name === server)[0].last_success_date
    }

    return (
        <Card className="mb-3">
            <Card.Header>
                <div className="d-flex justify-content-between">
                    <div>{dashboard ? "MB Status" : "Summary"}</div>
                    <div>{dashboard && <Link to="/system/mbStatus">Master Status Page</Link>}</div>
                </div>
            </Card.Header>
            <Card.Body>
                {dataLoaded && data ? (
                    <>
                        <div className="alert alert-success text-center max-width-100">
                            <h4 className="font-weight-bold">Action ID</h4>
                            <Number value={data.details.maxActionId} /> (<Number value={data.details.daysLeft} /> days left)
                        </div>
                        <div className="alert alert-warning p-2 text-center mt-2" style={{ backgroundColor: colors.yellowHighlight }}>
                            <h4 className="font-weight-bold">Clicks in past hour</h4>
                            Today: <Number value={data.details.clicksLastHourToday} /> Yesterday: <Number value={data.details.clicksLastHourYesterday} />
                        </div>
                        {/* <Table className="mt-2">
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }} className=" border rounded p-2 text-center"><FontAwesomeIcon className={serverColor(getStatus('WS1'))} icon="circle" /> WS 1 ({getLastSuccessDate('WS1') ? moment(getLastSuccessDate('WS1')).utc().format('YYYY-MM-DD hh:mm:ss A') : 'Never'})</td>
                                    <td style={{ width: '50%' }} className=" border rounded p-2 text-center"><FontAwesomeIcon className={serverColor(getStatus('WS2'))} icon="circle" /> WS 2 ({getLastSuccessDate('WS2') ? moment(getLastSuccessDate('WS2')).utc().format('YYYY-MM-DD hh:mm:ss A') : 'Never'})</td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ width: '50%' }} className=" border rounded p-2 text-center"><FontAwesomeIcon className={serverColor(data.details.applicationHealth[2].status)} icon="circle" /> WS ADMIN ({moment(data.details.applicationHealth[2].last_success_date).utc().format('YYYY-MM-DD hh:mm:ss A')})</td>
                                </tr>                                
                            </tbody>
                        </Table> */}

                        {ipqsUsageData &&
                            <Table className="mt-2">
                                <tbody>
                                    <tr>
                                        <td className="border rounded p-2 text-center">IPQS Usage ({moment(ipqsData.last_status_check_date).utc().format('YYYY-MM-DD hh:mm:ss A')}) </td>
                                        <td className={`border rounded p-2 text-center ${((ipqsData.total_usage) / ipqsData.total_credits) > 0.8 ? 'text-danger' : ''}`}><Number value={ipqsData.total_usage} /> / <Number value={parseInt(ipqsData.total_credits)} /> &nbsp;
                                            (<Number decimals={2} value={((parseInt(ipqsData.total_usage) / parseInt(ipqsData.total_credits)) * 100)} />%)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" className="border rounded p-2 text-center">
                                            <div className="d-flex justify-content-between w-75 mx-auto">
                                                <div><div className="font-weight-bold">Phone</div><Number value={ipqsData.phone_usage} /></div>
                                                <div><div className="font-weight-bold">IP</div> <Number value={ipqsData.ip_usage} /></div>
                                                <div><div className="font-weight-bold">Email</div> <Number value={ipqsData.email_usage} /></div>
                                            </div>                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        }
                        {sendgridUsageData &&
                            <Table className="mt-2">
                                <tbody>
                                <tr>
                                        <td className="border rounded p-2 text-center">SendGrid Usage
                                             ({moment(sendgridData.last_success_date).utc().format('YYYY-MM-DD hh:mm:ss A')}) </td>
                                        <td className={`border rounded p-2 text-center ${((sendgridData.param2) / (sendgridData.param1 + sendgridData.param2)) > 0.8 ? 'text-danger' : ''}`}><Number value={sendgridData.param2} /> / <Number value={parseInt(sendgridData.param1) + parseInt(sendgridData.param2)} /> 
                                            (<Number decimals={2} value={((parseInt(sendgridData.param2) / (parseInt(sendgridData.param1) + parseInt(sendgridData.param2))) * 100)} />%)
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        }
                    </>
                ) : (
                    <>
                        <div className="alert alert-success text-center max-width-100">
                            <h4 className="font-weight-bold">Action ID</h4>
                            Loading...
                        </div>
                        <div className="alert alert-warning p-2 text-center mt-2" style={{ backgroundColor: colors.yellowHighlight }}>
                            <h4 className="font-weight-bold">Clicks in past hour</h4>
                            Loading...
                        </div>
                        <Table className="mt-2">
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }} className=" border rounded p-2 text-center">Loading...</td>
                                    <td style={{ width: '50%' }} className=" border rounded p-2 text-center">Loading...</td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ width: '50%' }} className=" border rounded p-2 text-center">Loading...</td>
                                </tr>
                                {ipqsUsageData && <>
                                    <tr>
                                        <td colSpan="2" style={{ width: '50%' }} className=" border rounded p-2 text-center">Loading...</td>
                                    </tr>
                                </>}
                                {sendgridUsageData && <>
                                    <tr>
                                        <td colSpan="2" style={{ width: '50%' }} className=" border rounded p-2 text-center">Loading...</td>
                                    </tr>
                                </>}
                            </tbody>
                        </Table>

                    </>
                )
                }
            </Card.Body >

        </Card >
    )
}
// {
// 	"success":true,
// 	"message":"Success",
// 	"credits":3004522,
// 	"usage":478,
// 	"proxy_usage":6,
// 	"email_usage":472,
// 	"mobile_sdk_usage": 22,
// 	"phone_usage": 1231,
// 	"url_usage": 211,
// 	"fingerprint_usage":0,
// 	"request_id":"3ift1XN"
// }

export { Summary }